import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { ADMIN_NAV_WIDTH_COMPACT, ADMIN_NAV_WIDTH_EXPANDED } from '../../../web/constants/sizes';
import { BreakPoints } from '../../../web/styles/styles';

const {
	spacing: { sm, md, xl },
} = THEME;

export const HeaderHeight = 96;
export const CompactWidth = 1400;

export const styleSheet = StyleSheet.create({
	compactNav: {
		overflow: 'hidden',
		width: ADMIN_NAV_WIDTH_COMPACT,
		zIndex: 1,
		[BreakPoints.forMaxWidth(CompactWidth)]: {
			width: ADMIN_NAV_WIDTH_COMPACT,
		},
	},
	container: {
		background: '#fff',
		height: '100%',
		minWidth: 768,
		display: 'grid',
		gridTemplateColumns: `auto 1fr auto`,
		gridTemplateRows: '100%',
	},
	masthead: {
		height: HeaderHeight,
		flex: 'none',
		padding: `0 ${xl}px`,
		[BreakPoints.forMaxWidth(CompactWidth)]: {
			padding: `0 ${md}px`,
		},
	},
	fullBleedMasthead: {
		padding: `0 ${sm}px`,
		[BreakPoints.forMaxWidth(CompactWidth)]: {
			padding: `0 ${sm}px`,
		},
	},
	nav: {
		overflow: 'hidden',
		width: ADMIN_NAV_WIDTH_EXPANDED,
		zIndex: 1,
		flexShrink: 0,
		[BreakPoints.forMaxWidth(CompactWidth)]: {
			width: ADMIN_NAV_WIDTH_COMPACT,
		},
	},
	navHeaderBackground: {
		marginBottom: 40,
	},
	rightContainer: {
		overflowX: 'auto',
	},
	containerContent: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		minHeight: 0,
	},
	rightContainerScroller: {
		position: 'relative',
		flex: 1,
		minHeight: 0,
	},
	rightContainerScrollerContent: {
		boxSizing: 'border-box',
		height: '100%',
		overflow: 'auto',
		position: 'relative',
		padding: `0 ${xl}px`,
		display: 'flex',
		flexDirection: 'column',
		[BreakPoints.forMaxWidth(CompactWidth)]: {
			padding: `0 ${md}px`,
		},
	},
	fullBleedScrollerContent: {
		padding: 0,
		[BreakPoints.forMaxWidth(CompactWidth)]: {
			padding: 0,
		},
	},
});
